import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { activityApi } from "@/api";
import type { ActivityQuery } from "@/api";
import { QUERY_KEYS } from "@/constants";

/** Faollik jurnali — admin uchun; har bir filtr alohida kesh kaliti. */
export const useActivity = (query: ActivityQuery, enabled = true) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_ACTIVITY, query],
    queryFn: () => activityApi.list(query),
    placeholderData: keepPreviousData,
    enabled,
    select: res => ({ rows: res.data, meta: res.meta }),
  });
